import { http, httpFile } from './http_service';
// Get Single
export function single(id){
    return http().get(`/ss/single/${id}`);
}
// Update police check
export function update(id, data){
    return http().put(`/ss/update/${id}`, data)
}